import { Country } from '~/Api/Country';

export enum ErrorCode {
	cannotChangeSettingsForNonMemberProducts = 'lithuania-max-price-calculation-cannot-change-settings-for-non-member-products',
	illegalPriceTypeSelected = 'lithuania-max-price-illegal-price-type-selected',
	requiredProductSettingsMissing = 'lithuania-max-price-calculation-required-product-settings-is-missing',
	requiresMaxOneReferenceProduct = 'lithuania-max-price-calculation-requires-at-most-one-product-for-each-country',
	requiresMinOneReferenceProduct = 'lithuania-max-price-calculation-requires-at-least-one-reference-country-product',
	requiresReferenceSettings = 'lithuania-max-price-calculation-requires-reference-settings',
}

export class Error {
	public constructor(
		public code: string,
		public productId: string | null,
		public productGroupId: string | null,
		public duplicateCountries: Country[]
	) {}
}
